import { ReactComponent as DonutBase } from './donut_base.svg'
import { ReactComponent as CrullerBase } from './cruller_base.svg'
import { ReactComponent as JellyFilledBase } from './jelly_filled_base.svg'

const DonutTypes = {
  DonutBase,
  CrullerBase,
  JellyFilledBase,
}

export default DonutTypes
